import { useDarkMode } from '~/components/DarkMode/hook'
import { SEARCH_RESULT_TYPE, SearchResult, SearchSnippet } from '~/types/search'
import { getOperationColor } from '~/utils/shared/operationColor'

const HighlightedTitle = ({
  titleSnippet,
  removeLeadingSlash = false,
}: {
  titleSnippet: SearchSnippet[]
  removeLeadingSlash?: boolean
}) => (
  <>
    {titleSnippet.map((snippetItem, snippetIndex) => {
      const key = `titleSnippet-${snippetItem.text}-${snippetIndex}`
      const text =
        removeLeadingSlash && snippetIndex === 0 && snippetItem.text.startsWith('/')
          ? snippetItem.text.slice(1)
          : snippetItem.text

      return (
        <span
          key={key}
          className={snippetItem.highlight ? 'font-bold bg-neutral-10 dark:bg-neutral-85' : ''}
        >
          {text}
        </span>
      )
    })}
  </>
)

export const SearchResultTileTitle = ({ result }: { result: SearchResult}) => {
  const { isDark } = useDarkMode()

  const getTitleType = () => {
    if (result.resultType === SEARCH_RESULT_TYPE.ENDPOINT && result.method) {
      return (
        <div>
          <span style={{ color: getOperationColor(result.method, isDark()) }} className="font-semibold">
            {result.method.toUpperCase()}
          </span>
          {' / '}
          <HighlightedTitle titleSnippet={result.titleSnippet} removeLeadingSlash={!result.summary} />
        </div>
      )
    }

    return <HighlightedTitle titleSnippet={result.titleSnippet} />
  }

  return (
    <div
      className="mb-2 font-medium break-words text-body2 text-neutral-98 dark:text-neutral-10"
      role="heading"
      aria-level={3}
    >
      {getTitleType()}
    </div>
  )
}